import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";

// Shows an "Install app" button when the browser supports PWA installation.
// On Windows (Edge/Chrome) this installs the app to the Start menu as a standalone window.
export default function InstallPWA({ className = "", variant = "pill" }) {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferred(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    if (window.matchMedia("(display-mode: standalone)").matches) setInstalled(true);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch (e) {
      /* ignore */
    }
    setDeferred(null);
  };

  const base =
    variant === "pill"
      ? "inline-flex items-center gap-2 px-4 h-9 rounded-full text-sm font-medium bg-violet-600/20 border border-violet-500/40 text-white hover:bg-violet-600/30 transition shadow-[0_0_14px_rgba(168,85,247,0.25)]"
      : "inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-violet-300 hover:bg-violet-600/10 transition w-full";

  return (
    <button data-testid="install-pwa-button" onClick={install} className={`${base} ${className}`}>
      <Download size={16} />
      Zainstaluj aplikację
    </button>
  );
}
